import {createAction} from '@reduxjs/toolkit'

/** 개인고유부호 판매자 제공 체크박스 */
export const selectUses = createAction<'Y' | 'N'>('personalCustomsClearance/selectUses')
